import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { USD } from '../constants/currency-codes';

export const useSellerFormattedCurrency = (amount) => {
  const intl = useIntl();
  const sellerDefaultCurrencyCode = useSelector(Global.selectSellerDefaultCurrency) || USD;
  return intl.formatNumber(amount, {
    style: 'currency',
    currency: sellerDefaultCurrencyCode,
  });
};
